module.exports = __webpack_public_path__ + "static/media/service5.27f1e218.png";